import React from "react";
import { useNavigate } from "react-router-dom";
import { getDataOrNull } from "@msys/common";
import { SplashScreen } from "../../common/SplashScreen.js";
import { useApolloClient } from "@apollo/client";
import { useSapSalesQuotationQuoteRedirectRouteQuery } from "./SapSalesQuotationQuoteRedirectRoute.generated";

interface Props {
  salesQuotationId: string;
}

export function SapSalesQuotationQuoteRedirectRoute({
  salesQuotationId,
}: Props) {
  const navigate = useNavigate();

  const client = useApolloClient();
  const query = useSapSalesQuotationQuoteRedirectRouteQuery({
    client,
    variables: {
      salesQuotationId,
    },
    fetchPolicy: "cache-first",
  });

  const quoteSapS4HanaData = getDataOrNull(
    query.data?.quoteSapS4HanaDataBySalesQuotationId
  );

  React.useEffect(() => {
    if (!query.error) {
      const docId = quoteSapS4HanaData?.docId;
      const projectId = quoteSapS4HanaData?.projectId;
      if (docId && projectId) {
        navigate(`/projects/${projectId}/quotes/${docId}`);
      }
    }
  }, [
    navigate,
    quoteSapS4HanaData?.docId,
    quoteSapS4HanaData?.projectId,
    query.error,
  ]);

  return <SplashScreen />;
}
